import { render, staticRenderFns } from "./UserInfoHeader.vue?vue&type=template&id=6cd60087&"
import script from "./UserInfoHeader.vue?vue&type=script&lang=js&"
export * from "./UserInfoHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports